<mat-dialog-content class="mat-typography">

  <div style="display: flex; justify-content: space-between; flex-direction: row;">
    <h2 mat-dialog-title><strong> Memorandos </strong></h2>
    <div
      style="width: 30px; height: 30px; border-radius: 50%; display: flex; justify-content: center; align-items: center; cursor:pointer;"
      class="mat-elevation-z3" (click)="dialogRef.close()"><i class="fa fa-times "></i></div>
  </div>

  @if (tipoRedireccion=='nuevo') {
  <div>
    <mat-horizontal-stepper linear="true">
      <mat-step [stepControl]="firtsForm">
        <ng-template matStepLabel>Seleccion</ng-template>
        <form [formGroup]="firtsForm">
          <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 15px;">
            <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
              matStepperNext><i class="fa fa-arrow-right"></i></button>
          </div>
          <div style="display: none">
            <mat-form-field>
              <mat-label>Selección</mat-label>
              <input autocomplete="off" type="text" formControlName='selection' matInput required>
            </mat-form-field>
          </div>
          <data-table [columns]='columnasUsuarios' [configuration]='configurationUsuarios'
            (clickRow)='clickFilaUsuarios($event)' [params]="[{ id:'state', value: 1  }]"
            [url]='urlGetUsuarios'></data-table>
        </form>
      </mat-step>
      <mat-step [stepControl]="FormMemorandos">
        <ng-template matStepLabel>Informacion</ng-template>
        <form [formGroup]="FormMemorandos"
          (ngSubmit)="FormMemorandos.valid?saveForm(FormMemorandos.value):errorMessage()">
          <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
              matStepperPrevious><i class="fa fa-arrow-left"></i></button>
            <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
            @if (usuario) {
            <h3 style="margin: 10px"><strong>usuario: {{usuario}}</strong> </h3>
            }
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button matStepperNext
              type="submit"><i class="fa fa-arrow-right"></i></button>
          </div>
          <div style='display: flex; width: 100%; '>
            <div style='flex:12'>
              <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport">
                <div class='first-row'>
                  <div class='row-item'>
                    <mat-form-field [appOpenDatepickerOnClick]="pickerMemos">
                      <mat-label>Fecha</mat-label>
                      <input matInput [matDatepicker]="pickerMemos" autocomplete="off" matInput formControlName='date'
                        required>
                      <mat-datepicker-toggle matIconSuffix [for]="pickerMemos">
                      </mat-datepicker-toggle>
                      <mat-datepicker #pickerMemos [touchUi]='movil?true:false'></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>
                  <div class='row-item'>
                    <!-- Responsable // genered by-->
                    <combos [configuration]='combosConfigResponsable' [required]="true" [filter]="true"
                      (changeOptionDataComplete)="ValueResponsable($event)"
                      [control]="FormMemorandos.get('generatedBy')">
                    </combos>
                  </div>
                </div>
                <div class='default-row'>
                  <div class='row-item'>
                    <file-input [params]='fileInputMemorandos' (fileSave)='fileSaveMemorandos($event)'></file-input>
                  </div>
                </div>
                <div class='default-row'>
                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Descripción</mat-label>
                      <input autocomplete="off" type="text" formControlName='description' matInput #descripcion
                        maxlength="1024" placeholder="Descripción" required>
                      <mat-hint>{{descripcion.value.length}}/1024</mat-hint>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Finalizar</ng-template>
        <div class="mat-elevation-z2" style="display: flex; justify-content: space-between; margin-bottom: 30px;">
          <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
            matStepperPrevious><i class="fa fa-arrow-left"></i></button>
          <button class="mat-elevation-z2" mat-mini-fab color="warn" (click)="save()">
            <mat-icon>save</mat-icon>
          </button>
        </div>
        <div style="width: 100%; display: flex; flex-direction: row;">
          <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
  }


  @if (tipoRedireccion=='visualizar') {
  <div style="width: 100%; display: flex; flex-direction: row;">
    <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
  </div>
  }

</mat-dialog-content>

<ng-template #SummaryInformation>

  <div style="width: 50%; height: 100%; display: flex; flex-direction: column; text-align: center; align-self: center;">
    <div>
      <img src="{{imageSrc}}" [ngStyle]="sizePicture">
    </div>
  </div>

  <div style="text-align: center; width: 50%; height: 100%;">
    <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z1">
      <mat-tab label="">
        <mat-list>
          <mat-list-item>
            <span matListItemTitle>Nombre</span>
            {{ nombreSelecionado }}
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
            <span matListItemTitle>Usuario</span>
            {{ usuario }}
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
            <span matListItemTitle>Fecha</span>
            {{ fechaLabel }}
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
            <span matListItemTitle>Responsable</span>
            {{ generadoPorLabel }}
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
            <span matListItemTitle>Descripción</span>
            {{ descripcionLabel }}
          </mat-list-item>
          <mat-divider></mat-divider>
          @if (tipoRedireccion=='nuevo') {
          <mat-list-item>
            <span matListItemTitle>Anexo</span>
            {{ nameFile }}
          </mat-list-item>
          }
          <mat-divider></mat-divider>
          @if (tipoRedireccion=='visualizar') {
          <mat-list-item>
            <span matListItemTitle>Anexo:</span>
            <div matListItemMeta (click)="openAnexo()" class="cursor-pointer">
              <mat-icon>picture_as_pdf</mat-icon>
            </div>

          </mat-list-item>
          }

        </mat-list>
      </mat-tab>
    </mat-tab-group>
  </div>


</ng-template>